export class Cookie {
    public static getCookieUrl(cookieName: string, defaultUrl: string) {
        const cookieUrl = Cookie.readCookie(cookieName);
        if (cookieUrl !== null) {
            return cookieUrl;
        }

        return defaultUrl;
    }

    public static readCookie(name: string, requestCookie?: string) {
        try {
            const nameEQ = name + "=";
            const ca = (requestCookie || document.cookie).split(";");
            for (let c of ca) {
                while (c.startsWith(" ")) {
                    c = c.substring(1, c.length);
                }
                if (c.startsWith(nameEQ)) {
                    return c.substring(nameEQ.length, c.length);
                }
            }
        } catch (e) {
            // Helpers.sendWrapperLoadError uses this method to get some context
            // for the reported error, so we don't want to call that here, otherwise
            // we would get stuck in an infinite loop

            // Missing login_user_detected cookie is expected for logged out users, so no need to log it.
            if (name !== "login_user_detected") {
                console.warn(`Error reading cookie - ${name}`, e);
            }
        }
        return null;
    }

    public static writeCookie(
        name: string,
        value: string,
        days?: number | null,
        topLevelDomain?: boolean
    ) {
        const seconds = days ? days * 24 * 60 * 60 : null;

        Cookie.writeCookieInSeconds(name, value, seconds, topLevelDomain);
    }

    public static writeCookieInSeconds(
        name: string,
        value: string,
        seconds: number | null,
        topLevelDomain?: boolean
    ) {
        try {
            let expires = "";

            if (seconds) {
                const date = new Date();
                date.setTime(date.getTime() + seconds * 1000);
                expires = "; expires=" + date.toUTCString();
            }

            let cookie = name + "=" + value + expires + "; path=/;";

            let domain = window.location.hostname;
            if (domain !== "localhost" && topLevelDomain) {
                const domainTokens = domain.split(".");
                if (domainTokens.length > 2) {
                    const lastToken = domainTokens[domainTokens.length - 1];
                    const secondLastToken =
                        domainTokens[domainTokens.length - 2];
                    if (
                        isNaN(Number(lastToken)) ||
                        isNaN(Number(secondLastToken))
                    ) {
                        domain = "." + secondLastToken + "." + lastToken;
                    }
                } else if (domainTokens.length === 2) {
                    domain = "." + domain;
                }

                cookie += " domain=" + domain + ";";
            }
            document.cookie = cookie;
        } catch (e) {
            console.warn(`Error writing cookie - ${name}`, e);
        }
    }
}
